/**
 * bic-bim-api
 * Import from bic-bim-api Function App
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Prüfergebnis einer einzelnen Anforderung. Entspricht einer Zeile in der Attributübersicht-Tabelle (rechtes Panel) mit den Spalten: STATUS | Facette | Name | Wert | ERGEBNIS. Alle Werte werden vollständig geliefert (kein Informationsverlust). 
 */
export interface BicReportRequirement { 
    /**
     * Interner Typ der Anforderung aus dem IDS-Standard
     */
    facetType: BicReportRequirement.FacetTypeEnum;
    /**
     * Lokalisierte Bezeichnung für die \"Facette\"-Spalte. Mögliche Werte: \"Entität\", \"Attribut\", \"Klassifikation\", \"Eigenschaft\", \"Material\", \"Teilbeziehung\" 
     */
    facetTypeLabel: string;
    /**
     * Anzeigename für die \"Name\"-Spalte. Abhängig vom Facet-Typ: - Entity: IFC-Klassenname (z.B. \"IfcWall\") - Attribute: Attributname (z.B. \"Name\", \"Elevation\") - Property: Eigenschaftsname (z.B. \"Türnummer\", \"U-Wert\") - Classification: System-Name (z.B. \"NL-SfB tabel 1\") - Material: \"Material\" oder konkreter Materialwert - PartOf: Relationsname oder verknüpfte Entität 
     */
    name: string;
    /**
     * Vollständige Liste aller erwarteten Werte für die \"Wert\"-Spalte. Enthält ALLE Werte ohne Kürzung, z.B.: - Entity: [\"IfcWall\"] oder [\"IfcWall\", \"IfcSlab\"] - Attribute mit Enumeration: [\"-10 kelder\", \"-09 kelder\", ..., \"40 veertigste verdieping\"] - Classification: [\"11.10\", \"11.11\", \"11.12\", ...] - Property mit Bounds: [\"Min 4\", \"Max 10\"] - Leer wenn keine spezifischen Werte erwartet (nur Existenz) 
     */
    values: Array<string>;
    /**
     * Kardinalität der Anforderung
     */
    cardinality: BicReportRequirement.CardinalityEnum;
    /**
     * Erfüllungsgrad für die \"ERGEBNIS\"-Spalte (0.0 - 1.0)
     */
    result: number;
    /**
     * true wenn result == 1.0 (100% bestanden), für die \"STATUS\"-Spalte
     */
    status: boolean;
    /**
     * GUIDs der Elemente, die diese Anforderung bestanden haben
     */
    guidListCorrect: Array<string>;
    /**
     * GUIDs der Elemente, die diese Anforderung nicht bestanden haben
     */
    guidListFail: Array<string>;
}
export namespace BicReportRequirement {
    export type FacetTypeEnum = 'Entity' | 'Attribute' | 'Classification' | 'Property' | 'Material' | 'PartOf';
    export const FacetTypeEnum = {
        Entity: 'Entity' as FacetTypeEnum,
        Attribute: 'Attribute' as FacetTypeEnum,
        Classification: 'Classification' as FacetTypeEnum,
        Property: 'Property' as FacetTypeEnum,
        Material: 'Material' as FacetTypeEnum,
        PartOf: 'PartOf' as FacetTypeEnum
    };
    export type CardinalityEnum = 'required' | 'optional' | 'prohibited';
    export const CardinalityEnum = {
        Required: 'required' as CardinalityEnum,
        Optional: 'optional' as CardinalityEnum,
        Prohibited: 'prohibited' as CardinalityEnum
    };
}